module.exports = __webpack_public_path__ + "img/P39-zh.9b103574.png";